import { Component, Input, OnInit, inject } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import {
  dialogData as timelogSheetDialogData,
  genericDialogComponent,
} from '../genericDialog';
import { User } from 'BaseDataTypes';
import { TimelogSheet } from 'TimelogDataTypes';
import { TimelogSheetService } from 'TimelogServices/timelog-sheet-service';
import { UserService } from 'BaseServices/user-service';
import { MatInputModule } from '@angular/material/input';
import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { dialogInputTitleComponent } from '../../../../../../src/app/elements/dialog-input-title.component';
import { SaveButtonComponent } from '../../../../../../src/app/buttons/save-button/save-button.component';
import { DeleteButtonComponent } from '../../../../../../src/app/buttons/delete-button/delete-button.component';

@Component({
    selector: 'app-timelog-sheet-dialog',
    imports: [
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    dialogInputTitleComponent,
    SaveButtonComponent,
    DeleteButtonComponent
],
    templateUrl: './timelog-sheet-dialog.component.html',
    styleUrl: './timelog-sheet-dialog.component.css'
})
export class TimelogSheetDialogComponent
  extends genericDialogComponent
  implements OnInit
{
  readonly data =
    inject<timelogSheetDialogData<TimelogSheet[]>>(MAT_DIALOG_DATA);
  @Input() sheetData!: TimelogSheet;
  sheets: TimelogSheet[] = [];
  users: User[] = [];
  currentUser = this.userService.currentUser;
  dialogInputTitleComponent = dialogInputTitleComponent;

  constructor(
    public override dialogRef: MatDialogRef<TimelogSheetDialogComponent>,
    private timelogSheetService: TimelogSheetService,
    public userService: UserService
  ) {
    super(dialogRef);
    if (this.data.data.length > 1) {
      this.createNewSheet();
    } else {
      this.sheetClicked(this.data.data[0]);
    }
  }

  ngOnInit(): void {
    this.userService.getUsers().subscribe((result) => {
      this.users = result;
    });
  }

  sheetClicked(sheetData: TimelogSheet) {
    this.sheetData = sheetData;
  }

  createNewSheet() {
    this.sheetData = { id: 0, sheetName: '', sheetId: '', userId: 0 };
  }

  saveChanges() {
    this.timelogSheetService
      .updateSheets(this.sheetData)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }

  deleteSheet() {
    if (
      !confirm(
        'Er du sikker på at du vil slette dette sheet ' +
          this.sheetData.sheetName +
          '?'
      )
    ) {
      return;
    }
    this.timelogSheetService
      .deleteSheets(this.sheetData.id)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }
}
